{
  "common": {
    "to": "até",
    "from": "de"
  },
  "missing_info": {
    "clinical_history": "O que é o historial clínico?\n\nO historial veterinário inclui todas as visitas ao veterinário, seja por doença, acidente, ou até as consultas de rotina ou de vacinação, a data da visita e as notas veterinárias correspondentes. Cada página deste documento deve ser numerada e na página final necessitamos da assinatura e carimbo da clínica. Você também deve adicionar uma certificação de que as visitas registradas no histórico são as únicas vezes que seu animal esteve naquela clínica.\n\nComo obtenho o histórico médico? \n\nMuito fácil! Seu veterinário pode fornecer o histórico médico, basta perguntar. Se você foi a mais de uma clínica, deverá solicitá-lo em cada uma delas. Se você foi apenas a uma clínica para tomar vacinas, ainda precisaremos do histórico e para que essas visitas apareçam.",
    "vet_report": "Relatório veterinário\n\nO relatório veterinário é um documento que descreve os detalhes da consulta para a qual estás a solicitar o reembolso. Este deve conter a seguinte informação:\n    • Motivo da visita: por exemplo, \"o meu cão tem uma dor na pata.\"\n    • Sintomas presentes: por exemplo, \"dor ao toque, coxear, protuberância na pata...\"\n    • Data de início dos sintomas.\n    • Testes de diagnóstico realizados: por exemplo, radiografias, exame físico...\n    • Diagnóstico: por exemplo, \"traumatismo por contusão na pata traseira.\"\n    • Tratamento: por exemplo, \"repouso, creme anti-inflamatório, medicação...\"\n    • Data do check-up programada.",
    "invoice": "Fatura\n\nPara que uma fatura seja válida, deve conter as seguintes informações:\n    • Data de emissão da fatura.\n    • NIF da clínica veterinária ou farmácia.\n    • Número da fatura.\n    • A palavra 'Fatura'é obrigatória, pois não aceitamos talões, recibos de entrega ou orçamentos.\n    • O valor discriminado de acordo com os tratamentos ou medicamentos prescritos pelo veterinário.\n\nPode serque tenhas enviado uma fatura correta, mas a foto esteja desfocada, com baixa resolução ou que haja algo que nos impeça de ver claramente os dados da fatura. Envia-nos novamente uma foto nítida para que possamos verificar a informação corretamente.",
    "health": {
      "templates": [
        {
          "group": "INVOICE",
          "options": [
            {
              "label": "Unreadable",
              "value": "A fatura que você nos envia não pode ser lida corretamente ou está cortada. Por favor, envie o documento completo em formato PDF.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "One single document",
              "value": "Envia-nos a fatura como um único documento, preferencialmente em formato PDF. Tal como a enviaste, não conseguimos seguir a ordem do conteúdo corretamente. Se o teu veterinário te deu a fatura impressa e precisas de tirar fotos, certifica-te de que a fatura esteja toda visível numa só foto.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Duplicated invoice",
              "value": "Recebemos uma fatura desta clínica com o mesmo número de fatura mas para outro animal de estimação, pelo que não é válida. As faturas devem ter um número de fatura único, não podendo haver duas faturas do mesmo emissor e ano com o mesmo número de fatura. Vai à tua clínica e pede uma fatura válida.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Missing",
              "value": "Necessitamos que nos envies a fatura dos serviços realizados. Lembra-te que deve constar o NIF da clínica, o número da fatura e a data em que a despesa foi realizada.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "More than one pet",
              "value": "A fatura que nos enviaste tem custos associados a vários animais de estimação. Por favor, envia-nos uma fatura individual para cada animal de estimação segurado.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Wrong pet",
              "value": "A fatura que nos enviaste não corresponde ao animal segurado.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Advance payment",
              "value": "A fatura que nos enviaste não pode ser aceite, pois trata-se de um adiantamento. Pedimos-te o envio da fatura completa, com todos os conceitos discriminados e o preço individual de cada um.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Not an invoice",
              "value": "O documento que nos enviaste não é uma fatura. Não te preocupes, para a obteres deves voltar ao veterinário, ou à farmácia, e pedir que te emita uma fatura. Deve constar o NIF/NIPC da clínica, o número da fatura e a data em que foi efetuada a despesa. De acordo com as condições da apólice, apenas podemos aceitar faturas. Tem em conta que orçamentos, faturas pró-forma, faturas simplificadas ou faturas número 0 não são válidas.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Unpaid invoice",
              "value": "A fatura não está paga ou só pagaste parte dela. Apenas aceitamos faturas totalmente pagas.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "NIF",
              "value": "Na fatura que nos enviaste, falta o NIF ou está incompleto.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Invoice number",
              "value": "Na fatura que nos enviaste, falta o número da fatura\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "The receipt covers the invoice",
              "value": "O recibo está a tapar a fatura e não é possível ler o seu conteúdo.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Screenshots not accepted",
              "value": "Recebemos o teu pedido de reembolso, mas não podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em PDF e anexa-os através da app."
            }
          ]
        },
        {
          "group": "CLINICAL_HISTORY",
          "options": [
            {
              "label": "Loose sheets",
              "value": "Necessitamos que nos envies o historial clínico num único documento. Infelizmente, não aceitamos folhas soltas ou folhas desordenadas."
            },
            {
              "label": "clinical history",
              "value": "Necessitamos que nos envies o historial veterinário do teu animal de estimação desde que começou a viver contigo. Deves solicitá-lo em todas as clínicas onde o teu animal tenha sido atendido. O historial deve incluir: Todas as visitas ao veterinário, seja para vacinas, consultas de rotina, doenças ou acidentes. A data de cada visita e as notas registadas pelo veterinário. Uma confirmação de que o historial está completo: o veterinário deve escrever algo como “Não há mais visitas registadas nesta clínica.” Assinatura e carimbo da clínica. Um historial por cada clínica: se o teu animal foi atendido em mais do que uma clínica, precisamos de um historial de cada uma, mesmo que tenha sido apenas para vacinação. Não aceitamos folhas soltas nem documentos incompletos."
            },
            {
              "label": "Incomplete",
              "value": {
                "group": "Que falta?",
                "options": [
                  {
                    "label": "Condition",
                    "value": "No historial que nos envias, falta a visita relacionada com a condição [INPUT] mencionada no relatório veterinário."
                  },
                  {
                    "label": "Clinic data",
                    "value": "No historial que nos enviaste faltam os dados da clínica ou estão incompletos. Deve aparecer o nome da clínica, o seu NIF e morada."
                  },
                  {
                    "label": "Pet details",
                    "value": "No historial falta algum ou todos os seguintes dados do animal: nome, raça e/ou chip."
                  },
                  {
                    "label": "Visits",
                    "value": "No historial que nos enviaste, faltam as seguintes datas: de [DD/MM/AA] a [DD/MM/AA], de [DD/MM/AA] a [DD/MM/AA]."
                  },
                  {
                    "label": "Clinical notes",
                    "value": "No historial que nos enviaste, faltam as notas clínicas de cada visita ao veterinário."
                  },
                  {
                    "label": "One or more clinics",
                    "value": "Necesitamos que nos envies o historial de todas as clínicas que acudsite com o teu animal."
                  }
                ]
              }
            },
            {
              "label": "Not a clinical history",
              "value": "O documento que nos enviaste não é um historial. Solicita-o em todas as clínicas onde o teu animal tenha sido atendido. O historial deve incluir: \n- Todas as visitas ao veterinário: seja para vacinas, consultas de rotina, doenças ou acidentes. \n- A data de cada visita e as notas que o veterinário escreveu. \n- Uma confirmação de que está completo: o veterinário deve escrever algo como: 'Não há mais visitas registadas nesta clínica.' \n- Assinado e carimbado pela clínica. \n- Um historial por cada clínica: se o teu animal foi atendido em mais de uma clínica, precisamos de um historial por cada uma, mesmo que tenha sido apenas para vacinação. \n- Não aceitamos folhas soltas nem documentos incompletos."
            },
            {
              "label": "Repeated attempts",
              "value": "Como já te dissemos anteriormente, sem o historial do teu animal de estimação não podemos processar o teu pedido. Solicita-o em todas as clínicas onde o teu animal tenha sido atendido. O historial deve incluir: \n- Todas as visitas ao veterinário: seja para vacinas, consultas de rotina, doenças ou acidentes. \n- A data de cada visita e as notas que o veterinário escreveu. \n- Uma confirmação de que está completo: o veterinário deve escrever algo como: 'Não há mais visitas registadas nesta clínica.' \n- Assinado e carimbado pela clínica. \n- Um historial por cada clínica: se o teu animal foi atendido em mais de uma clínica, precisamos de um historial por cada uma, mesmo que tenha sido apenas para vacinação. \n- Não aceitamos folhas soltas nem documentos incompletos."
            }
          ]
        },
        {
          "group": "VET_REPORT",
          "options": [
            {
              "label": "Changes",
              "value": "O relatório veterinário é um documento oficial, pelo que não podem ser aceites alterações ao mesmo. Para podermos avaliar este pedido, necessitamos que o teu veterinário nos escreva um relatório carimbado, com o seu nome completo, número de registo e assinado, justificando o motivo da alteração do relatório.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Sessions",
              "value": "Necessitamos de um relatório que inclua todas as sessões realizadas e a data de cada uma delas. Envia-nos este relatório no final do tratamento, pois não podemos reembolsar um tratamento que ainda não tenha sido realizado.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Starting date of symptoms",
              "value": {
                "group": "Quem deve indicar a data de início dos sintomas?",
                "options": [
                  {
                    "label": "petparent",
                    "value": "Necessitamos que nos indiques a data de início dos sintomas.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF.",
                    "type": "DATE"
                  },
                  {
                    "label": "veterinarian",
                    "value": "No relatório que nos enviaste, falta a data de início dos sintomas. Por favor, pede ao teu veterinário que a indique e inclua uma breve explicação escrita sobre quando os sintomas surgiram pela primeira vez.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  }
                ]
              }
            },
            {
              "label": "Inconsistency",
              "value": "Detetámos as seguintes incoerências nos documentos que nos enviaste: . Precisamos de um esclarecimento por parte do teu veterinário num relatório.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "One single document",
              "value": "Envia-nos o relatório como um único documento, de preferência em formato PDF. Tal como o enviaste, não conseguimos seguir corretamente a ordem do conteúdo. Se o teu veterinário te deu o relatório impresso e precisas de lhe tirar fotografias, certifica-te de que envias cada página numa fotografia separada, que se veja por completo e na ordem correta.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Costline explanation",
              "value": "Pede ao teu veterinário que inclua num relatório ou anexo à fatura a que tratamento se refere os seguintes elementos da fatura: [INPUT]. É necessário indicá-lo com o nome do tratamento e o preço correspondente.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Missing vet report",
              "value": {
                "group": "Que falta?",
                "options": [
                  {
                    "label": "Clinic",
                    "value": "Falta o relatório veterinário das seguintes clínicas: .\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "All",
                    "value": "Precisamos do relatório veterinário. Este deve ser um documento redigido pelo veterinário que detalhe a consulta pela qual solicitas o reembolso. O relatório deve incluir o seguinte:\nMotivo da consulta: Ex.: \"O meu cão tem dor na pata.\"\nSintomas observados: Ex.: \"Dor ao toque, coxeira, caroço na pata.\"\nData de início dos sintomas.\nExames realizados: Ex.: \"Radiografias, exame físico.\"\nDiagnóstico: Ex.: \"Traumatismo por contusão na pata traseira.\"\nTratamento indicado: Ex.: \"Repouso, medicação.\"\nCarimbo e a assinatura do médico veterinário.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "Dates",
                    "value": "Falta o relatório veterinário das seguintes datas: .\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  }
                ]
              }
            },
            {
              "label": "Incomplete",
              "value": {
                "group": "Que falta?",
                "options": [
                  {
                    "label": "Invoice costlines",
                    "value": "O relatório veterinário não menciona alguns dos conceitos que aparecem na fatura. Por exemplo, se a fatura incluir medicação mas o relatório não o indicar, precisamos que o veterinário o atualize, incluindo todos os tratamentos realizados.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "Clinic data",
                    "value": "No relatório falta algum ou todos os seguintes dados da clínica: nome, NIF e morada.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "Pet details",
                    "value": "No relatório falta algum ou todos os seguintes dados do animal: nome, raça e/ou chip.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "Date of visit",
                    "value": "No relatório a data da visita veterinária está em falta ou não se consegue ler corretamente\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "Diagnosis",
                    "value": "No relatório veterinário falta o diagnóstico do teu animal de estimação. Por favor, pede ao veterinário que o complete corretamente. Tenha em conta que sinais como comichão, claudicação ou tosse são apenas sintomas e não constituem um diagnóstico.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "Pages",
                    "value": "Faltam páginas ao relatório que nos enviaste, está incompleto.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "Diagnostic tests",
                    "value": "No relatório faltam os exames de diagnóstico realizados ao teu animal de estimação (como radiografias, análises, etc.)\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "Symptoms/reason for visit",
                    "value": "No relatório falta incluir o motivo pelo qual acudiste à consulta veterinária, ou seja, uma descrição clara dos sintomas que o teu animal de estimação apresenta.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "Treatment",
                    "value": "No relatório falta o tratamento prescrito ao teu animal de estimação\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "Carimbo",
                    "value": "Necessitamos que o relatório tenha o carimbo e a assinatura original do médico veterinário, já que não podemos aceitar o formato atual.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  }
                ]
              }
            },
            {
              "label": "Doesn't match the invoice",
              "value": "O relatório que nos envias não corresponde à fatura. Certifica-te de que o relatório tem a mesma data que a fatura e que inclui os itens que estão a ser cobrados na fatura.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Not a vet report",
              "value": "O documento que nos enviaste não é um relatório veterinário. O relatório veterinário é um documento que descreve os detalhes da consulta para a qual estás a solicitar o reembolso. Este deve conter: \n- Motivo da visita. E.g: O Meu cão tem uma dor na pata\n- Sintomas presentes. E.g: Dor ao toque, coxear, protuberância na pata\n- Data de início dos sintomas\n- Testes de diagnóstico realizados. E.g: Radiografias ou exame físico\n- Diagnóstico. E.g: Traumatismo por contusão na pata traseira\n- Tratamento. E.g: Repouso, medicação\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Unreadable",
              "value": "O relatório veterinário que você nos enviou não pode ser lido corretamente ou está cortado. Por favor, envie o relatório completo em formato PDF.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Chronic condition",
              "value": "Para doenças com medicação crónica, precisamos de um relatório de acompanhamento a cada 6 meses. Por isso, para continuar com a tua solicitação, precisamos do relatório desta patologia.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Treatments",
              "value": "No documento que nos enviaste, podemos ver os tratamentos recomendados pelo veterinário, mas necessitamos de um relatório completo da visita.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Previous vet reports",
              "value": "Necessitamos dos relatórios das consultas anteriores relativas a esta doença, especificando os sintomas, a data de início, os testes realizados, os tratamentos prescritos e a evolução.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Related visits",
              "value": "Necessitamos que nos envies os relatórios anteriores relacionados com a visita.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Costline breakdown",
              "value": "Pede ao teu veterinário que indique, num relatório ou anexo à fatura, cada serviço ou tratamento realizado no animal de estimação e o respetivo preço individual\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },{"label": "Screenshots Not Accepted","value": "Recebemos o teu pedido de reembolso, mas não podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em PDF e anexa-os através da app."}
          ]
        },
        {
          "group": "ADMINISTRATIVE_DOCUMENTATION",
          "options": [
            {
              "label": "IBAN",
              "value": "Precisamos que nos envies o teu número IBAN.",
              "type": "IBAN"
            },
            {
              "label": "Chip registration certificate",
              "value": "Necessitamos que nos envies o certificado de registo do chip do teu animal de estimação"
            },
            {
              "label": "Purchase or adoption contract",
              "value": {
                "group": "O que acontece?",
                "options": [
                  {
                    "label": "Missing",
                    "value": "Necessitamos que nos envies o contrato de compra ou adoção do teu animal de estimação."
                  },
                  {
                    "label": "Unreadable",
                    "value": "O documento que nos enviaste não se consegue ler corretamente."
                  }
                ]
              }
            }
          ]
        },
        {
          "group": "MEDICAL_IMAGING",
          "options": [
            {
              "label": "Ultrasound",
              "value": {
                "group": "O que acontece?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Ecografia: Necessitamos que o teu veterinário redija um relatório carimbado, com o seu nome completo, número de registo e assinado, explicando o motivo da alteração do documento."
                  },
                  {
                    "label": "Missing",
                    "value": "Necessitamos do relatório original da ecografia realizada. O relatório deve incluir os dados do animal de estimação e a data de realização do teste"
                  },
                  {
                    "label": "Unreadable",
                    "value": "A ecografia que nos enviaste não se consegue ler corretamente."
                  }
                ]
              }
            },
            {
              "label": "Radiography",
              "value": {
                "group": "O que acontece?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Radiografia: Necessitamos que o teu veterinário redija um relatório carimbado, com o seu nome completo, número de registo e assinado, explicando o motivo da alteração do documento."
                  },
                  {
                    "label": "Missing",
                    "value": "Necessitamos que nos anexes as radiografias realizadas com marca de água original ou formato DICOM (.dcm)."
                  },
                  {
                    "label": "Original images",
                    "value": "Necessitamos das imagens originais da radiografia realizada. Estas podem estar em formato DICOM (.dcm). Este formato é como o jpg das fotografias. Embora não as consigas abrir, nós conseguimos."
                  },
                  {
                    "label": "Unreadable",
                    "value": "A radiografia que nos enviaste não se consegue ver corretamente."
                  }
                ]
              }
            },
            {
              "label": "MRI",
              "value": {
                "group": "O que acontece?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Ressonância: Necessitamos que o teu veterinário redija um relatório carimbado, com o seu nome completo, número de registo e assinado, explicando o motivo da alteração do documento."
                  },
                  {
                    "label": "Missing",
                    "value": "Necessitamos o relatório original da ressonância realizada. O relatório deve incluir os dados do animal de estimação e a data de realização do teste."
                  },
                  {
                    "label": "Unreadable",
                    "value": "A ressonância que nos enviaste não se consegue ler corretamente."
                  }
                ]
              }
            },
            {
              "label": "CT-Scan",
              "value": {
                "group": "O que acontece?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "TAC: Necessitamos que o teu veterinário redija um relatório carimbado, com o seu nome completo, número de registo e assinado, explicando o motivo da alteração do documento."
                  },
                  {
                    "label": "Missing",
                    "value": "Necessitamos do relatório original do TAC realizado. O relatório deve incluir os dados do animal de estimação e a data de realização do teste."
                  },
                  {
                    "label": "Unreadable",
                    "value": "O TAC que nos enviaste não se consegue ler corretamente."
                  }
                ]
              }
            }
          ]
        },
        {
          "group": "MEDICAL_ANALYTIC",
          "options": [
            {
              "label": "Urine test",
              "value": {
                "group": "O que acontece?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Análise de urina: Necessitamos que o teu veterinário redija um relatório carimbado, com o seu nome completo, número de registo e assinado, explicando o motivo da alteração do documento.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "Missing",
                    "value": "Análise de urina: Necessitamos dos resultados ou do documento original do teste realizado. O relatório deve incluir os dados do animal de estimação e a data de realização do teste.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Análise de urina: O documento que nos enviaste não se consegue ler corretamente.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  }
                ]
              }
            },
            {
              "label": "Blood tests",
              "value": {
                "group": "O que acontece?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Análise: Necessitamos que o teu veterinário redija um relatório carimbado, com o seu nome completo, número de registo e assinado, explicando o motivo da alteração do documento.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "Missing",
                    "value": "Análise: Necessitamos dos resultados ou do documento original do teste realizado. O relatório deve incluir os dados do animal de estimação e a data de realização do teste.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Análise: O documento que nos enviaste não se consegue ler corretamente.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  }
                ]
              }
            },
            {
              "label": "Biopsy",
              "value": {
                "group": "O que acontece?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Biópsia: Necessitamos que o teu veterinário redija um relatório carimbado, com o seu nome completo, número de registo e assinado, explicando o motivo da alteração do documento.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "Missing",
                    "value": "Precisamos dos resultados ou do documento original da biópsia realizada. O relatório deve incluir os dados do animal e a data de realização do exame.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Biópsia: O documento que nos enviaste não se consegue ler corretamente.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  }
                ]
              }
            },
            {
              "label": "Cytology",
              "value": {
                "group": "O que acontece?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Citologia: Necessitamos que o teu veterinário redija um relatório carimbado, com o seu nome completo, número de registo e assinado, explicando o motivo da alteração do documento.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "Missing",
                    "value": "Precisamos dos resultados ou do documento original da citologia realizada. O relatório deve incluir os dados do animal e a data de realização do exame.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Citologia: O documento que nos enviaste não se consegue ler corretamente.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  }
                ]
              }
            }
          ]
        },
        {
          "group": "VACCINATION_CARD",
          "options": [
            {
              "label": "Vaccination card",
              "value": {
                "group": "O que acontece?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Necessitamos que o teu veterinário redija um relatório carimbado, com o seu nome completo, número de registo e assinado, explicando o motivo da alteração do documento."
                  },
                  {
                    "label": "Missing",
                    "value": "Necessitamos que nos envies uma foto do boletim de vacinas ou do passaporte onde aparecem os dados do animal de estimação e todas as vacinas que recebeu."
                  },
                  {
                    "label": "Unreadable",
                    "value": "O documento que nos enviaste não se consegue ler corretamente."
                  },
                  {
                    "label": "Chipnumber",
                    "value": "É necessário que nos envies uma fotografia do boletim de vacinas ou do passaporte com o número do chip do animal de estimação."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    "prevention": {
      "templates": [
        {
          "group": "VACCINATION_CARD",
          "options": [
            {
              "label": "Changes",
              "value": "Necessitamos que o teu veterinário redija um relatório carimbado, com o seu nome completo, número de registo e assinado, explicando o motivo da alteração do documento."
            },
            {
              "label": "Missing",
              "value": "Necessitamos que nos envies uma foto do boletim de vacinas ou do passaporte onde aparecem os dados do animal de estimação e todas as vacinas que recebeu."
            },
            {
              "label": "Unreadable",
              "value": "O documento que nos enviaste não se consegue ler corretamente."
            },
            {
              "label": "IBAN",
              "value": "Precisamos que nos envies o teu número IBAN.",
              "type": "IBAN"
            },
            {
              "label": "Chipnumber",
              "value": "É necessário que nos envies uma fotografia do número do chip do teu animal de estimação. Pode ser o certificado de registo do microchip ou a página do passaporte onde estão indicados os dados do animal."
            }
          ]
        },
        {
  "group": "CLINICAL_HISTORY",
  "options": [
    {
      "label": "Missing",
      "value": "Precisamos que nos envie o histórico veterinário do seu animal de estimação desde que vive consigo. Solicite-o em todas as clínicas onde foi atendido. Deve incluir:\n - <b>Todas as visitas ao veterinário:</b> Seja para vacinas, consultas de rotina, doenças ou acidentes.\n - <b>A data de cada visita</b> e as notas escritas pelo veterinário.\n - <b>Uma confirmação de que está completo:</b> O veterinário deve escrever algo como: 'Não existem mais visitas registadas nesta clínica'.\n - <b>Assinado e carimbado pela clínica.</b>\n - <b>Um histórico por cada clínica:</b> Se visitou mais do que uma clínica, precisamos de um histórico de cada uma, mesmo que tenha sido apenas para vacinar o seu animal.\n - <b>Não aceitamos folhas soltas nem documentos incompletos.</b>"
    }
  ]
},
{
  "group": "MEDICAL_IMAGING",
  "options": [
    {
      "label": "Missing",
      "value": "Precisamos do relatório original do exame realizado. O relatório deve incluir os dados do animal e a data de realização do exame"
    }
  ]
},
{
  "group": "MEDICAL_ANALYTIC",
  "options": [
    {
      "label": "Missing",
      "value": "Precisamos do relatório original das análises realizadas. O relatório deve incluir os dados do animal e a data de realização do exame\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
    }
  ]
},
{
  "group": "ADMINISTRATIVE_DOCUMENTATION",
  "options": [
    {
      "label": "Chip registration certificate",
      "value": "Precisamos que nos envie o certificado de registo do microchip do seu animal de estimação."
    },
    {
      "label": "Purchase or adoption contract",
      "value": {
        "group": "O que acontece?",
        "options": [
          {
            "label": "Missing",
            "value": "Precisamos que nos envie o contrato de compra ou adoção do seu animal de estimação."
          },
          {
            "label": "Unreadable",
            "value": "Contrato de compra ou adoção: O documento que nos enviou não pode ser lido corretamente."
          }
        ]
      }
    },
    {
      "label": "IBAN",
      "value": "Precisamos do seu número IBAN",
      "type": "IBAN"
    }
  ]
},
        {
          "group": "INVOICE",
          "options": [
            {
              "label": "Changes",
              "value": "Necessitamos que o teu veterinário redija um relatório carimbado, com o seu nome completo, número de registo e assinado, explicando o motivo da alteração do documento. \n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Duplicated ",
              "value": "Recebemos uma fatura desta clínica com o mesmo número de fatura mas para outro animal de estimação, pelo que não é válida. As faturas devem ter um número de fatura único, não podendo haver duas faturas do mesmo emissor e ano com o mesmo número de fatura. Vai à tua clínica e pede uma fatura válida.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "More than one pet",
              "value": "A fatura que nos enviaste tem custos associados a vários animais de estimação. Por favor, envia-nos uma fatura individual para cada animal de estimação segurado.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Complete invoice",
              "value": "Precisamos da fatura completa. Descarrega a fatura em formato PDF e envia-nos o documento na secção da fatura. Não podemos aceitar faturas em várias capturas de ecrã."
            },
            {
              "label": "One single document",
              "value": "Envia-nos a fatura como um único documento, de preferência em formato PDF. Tal como foi enviada, não conseguimos seguir corretamente a ordem do conteúdo. Se o teu veterinário te entregou a fatura impressa e precisares de lhe tirar fotografias, certifica-te de que fica completamente visível numa única foto.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "NIF",
              "value": "Na fatura que nos enviaste falta o NIF/NIPC da clínica ou está incompleto.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Invoice number",
              "value": "Na fatura que nos enviaste falta o número da fatura ou está incompleto.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Missing",
              "value": "Precisamos que nos envies a fatura dos serviços realizados. Lembra-te de que deve constar o número de NIF/NIPC da clínica, o número da fatura e a data em que foi efetuada a despesa.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Not an invoice",
              "value": "O documento que nos enviaste não é uma fatura. Não te preocupes, para a obteres deves voltar ao veterinário, ou à farmácia, e pedir que te emita uma fatura. Deve constar o NIF/NIPC da clínica, o número da fatura e a data em que foi efetuada a despesa. De acordo com as condições da apólice, apenas podemos aceitar faturas. Tem em conta que orçamentos, faturas pró-forma, faturas simplificadas ou faturas número 0 não são válidas.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Unreadable",
              "value": "A fatura que você nos envia não pode ser lida corretamente ou está cortada. Por favor, envie o documento completo em formato PDF.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "The receipt covers the invoice",
              "value": "O recibo está a tapar a fatura e não é possível ler o seu conteúdo.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Screenshots not accepted",
              "value": "Recebemos o teu pedido de reembolso, mas não podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em PDF e anexa-os através da app."
            }
          ]
        },
        {
          "group": "VET_REPORT",
          "options": [
            {
              "label": "Changes",
              "value": "Necessitamos que o teu veterinário redija um relatório carimbado, com o seu nome completo, número de registo e assinado, explicando o motivo da alteração do documento.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Costline explanation",
              "value": "Pede ao teu veterinário que inclua num relatório ou anexo à fatura a que tratamento se refere cada uma das seguintes rubricas de custo apresentadas na fatura: [INPUT]. É necessário indicá-lo com o nome do tratamento e o preço correspondente.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Doesn't match the invoice",
              "value": "O relatório que nos enviaste não corresponde à fatura. As faturas devem estar sempre relacionadas com os relatórios.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Missing",
              "value": {
                "group": "Que falta?",
                "options": [
                  {
                    "label": "Clinic",
                    "value": "Falta o relatório veterinário das seguintes clínicas: .\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "All",
                    "value": "Precisamos do relatório veterinário. Este deve ser um documento redigido pelo veterinário que detalhe a consulta pela qual solicitas o reembolso. O relatório deve incluir o seguinte:\nMotivo da consulta: Ex.: \"O meu cão tem dor na pata.\"\nSintomas observados: Ex.: \"Dor ao toque, coxeira, caroço na pata.\"\nData de início dos sintomas.\nExames realizados: Ex.: \"Radiografias, exame físico.\"\nDiagnóstico: Ex.: \"Traumatismo por contusão na pata traseira.\"\nTratamento indicado: Ex.: \"Repouso, medicação.\"\nCarimbo e a assinatura do médico veterinário.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  },
                  {
                    "label": "Dates",
                    "value": "Falta o relatório veterinário das seguintes datas: .\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  }
                ]
              }
            },
            {
              "label": "Not a vet report",
              "value": "O relatório veterinário que você nos enviou não pode ser lido corretamente ou está cortado. Por favor, envie o relatório completo em formato PDF.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Unreadable",
              "value": "O documento que nos enviaste não se consegue ler corretamente.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Costline breakdown",
              "value": "Pede ao teu veterinário que indique, num relatório ou anexo à fatura, cada serviço ou tratamento realizado no animal de estimação e o respetivo preço individual.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
            },
            {
              "label": "Incomplete",
              "value": {
                "group": "Que falta?",
                "options": [
                  {
                    "label": "Carimbo",
                    "value": "Necessitamos que o relatório tenha o carimbo e a assinatura original do médico veterinário, já que não podemos aceitar o formato atual.\n\nNão podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em formato PDF."
                  }
                ]
              }
            },{"label": "Screenshots Not Accepted","value": "Recebemos o teu pedido de reembolso, mas não podemos aceitar capturas de ecrã nem fotografias de ecrãs dos documentos. Por favor, pede à tua clínica os documentos em PDF e anexa-os através da app."}
          ]
        }
      ]
    }
  },
  "resolution": {
    "templates": [
      {
                "group": "Waiting period",
        "options": [
          {
                        "label": "5 DAYS WAITING PERIOD / PREEXISTENCE",
                        "value": "Após a revisão da documentação de {{petName}}, informamos que a sua fatura, ou parte dela, não pôde ser aprovada. A sua apólice tem um período de carência de 5 dias para acidentes a partir da data de início do contrato. Neste caso, a condição indicada: {{condition;STRING;true}}, surgiu ou recebeu atenção veterinária em: {{date;DATE;true}}, dentro desses 5 dias. Por este motivo, não fica coberta pelo seguro e é considerada preexistente. Se esta condição se prolongar no tempo ou voltar a manifestar-se no futuro de forma recorrente ou crónica, nem este episódio nem eventuais recaídas ou complicações dele resultantes poderão ser reembolsados, independentemente da data do diagnóstico definitivo."
          },
                                {
                        "label": "28 DAYS WAITING PERIOD / PREEXISTENCE",
                        "value": "Após analisarmos a documentação de {{petName}}, informamos que a sua fatura, ou parte dela, não pôde ser aprovada. A sua apólice tem um período de carência de 28 dias para doenças a partir da data de contratação. A apólice define uma lista específica de situações com carência reduzida de 5 dias, e esta condição infelizmente não está incluída nessa lista, pelo que se aplica a carência geral de 28 dias. Neste caso, a condição indicada: {{condition;STRING;true}}, surgiu ou recebeu atenção veterinária em: {{date;DATE;true}}, dentro desses 28 dias, e é classificada como doença por não cumprir as condições estabelecidas pela apólice para ser considerada um acidente. Por este motivo, não fica coberta pelo seguro e é considerada uma condição pré-existente. Se esta condição se prolongar no tempo ou voltar a manifestar-se no futuro de forma recorrente ou crónica, nem este episódio nem eventuais recaídas ou complicações dele derivadas poderão ser reembolsados, independentemente da data do diagnóstico definitivo."
          },
          {
                        "label": "6 MONTH WAITING PERIOD / PREEXISTENCE",
                        "value": "Após analisarmos a documentação de {{petName}}, informamos que a sua fatura, ou parte dela, não pôde ser aprovada. A sua apólice tem um período de carência de 6 meses para determinadas doenças a partir da data de contratação. Entre estas doenças incluem-se: displasia da anca, displasia do cotovelo, rotura ou doença do ligamento cruzado, luxação da rótula, atopia, dermatite alérgica, epilepsia, distúrbios de comportamento, leishmaniose, cataratas e hérnia discal. Se o animal tinha mais de 6 meses de idade quando a apólice foi contratada, estas doenças estão sujeitas a este período de 6 meses, ainda que a sua origem possa estar relacionada com um acontecimento inesperado. Neste caso, a condição indicada: {{condition;STRING;true}}, surgiu ou foi tratada em: {{date;DATE;true}}, dentro desse período de 6 meses. Por este motivo, não está coberta pelo seguro e é considerada preexistente. Esta condição permanecerá também excluída da cobertura no futuro: uma vez que os primeiros sintomas ou a primeira visita veterinária relacionada ocorreram dentro do período de carência da apólice, não podemos aprovar futuros pedidos de reembolso relacionados com esta condição, nem com qualquer sintoma, lesão ou doença dela derivada. Esta condição será considerada preexistente de forma permanente, mesmo que o diagnóstico definitivo venha a ser confirmado posteriormente."
          },
          {
            "label": "Leishmania",
            "value": "Leishmaniose. A leishmaniose é uma doença crónica, que leva meses ou até anos a desenvolver-se após a infeção. O teu animal de estimação foi diagnosticado com uma infeção avançada ou moderada (Fase __ - doença moderada/avançada). Tendo em conta o desenvolvimento lento desta doença e a data em que os sintomas apareceram, a doença estava já ativa e presente durante o período de carência da apólice ou antes da sua contratação."
          }
        ]
      },
      {
                "group": "Preexistence",
        "options": [
                                            {
            "value": "Após analisar a documentação de {{petName}}, informamos que a sua fatura, ou parte dela, não pôde ser aprovada.\n\nA condição que o seu animal apresenta: {{condition;STRING;true}}, é considerada pré-existente, uma vez que surgiu, apresentou sintomas ou foi tratada pela primeira vez em: {{date;DATE;true}}, antes do início da cobertura.\n\nUma condição pré-existente é qualquer lesão ou doença que: tenha ocorrido ou apresentado sintomas clínicos antes do início da cobertura da apólice, ou tenha o mesmo diagnóstico ou os mesmos sintomas de uma lesão ou doença que o animal já tivesse antes do início da cobertura, ou seja causada por, relacionada com ou derivada de uma lesão, doença ou sintoma clínico anterior ao início da cobertura.\n\nAlém disso, esta condição ficará também excluída da cobertura no futuro. Isto significa que não podemos aprovar futuros pedidos de reembolso relacionados com esta condição, nem com qualquer sintoma, lesão ou doença dela derivada, mesmo que o diagnóstico definitivo venha a ser confirmado mais tarde.",
                      "label": "Preexistence/before contract"
                                },{
            "label": "Date outside policy contract",
            "value": "Fatura prévia à contratação da apólice: Infelizmente, o teu pedido de reembolso foi recusado porque a data da fatura que nos enviaste é anterior à data de início da apólice."
          },
          {
            "label": "Not an accident denial",
            "value": "Analisámos o teu pedido e, de acordo com as Condições Gerais da tua apólice, esta situação não pode ser considerada um Acidente para efeitos da cobertura.\n\nA apólice estabelece que, para que um caso seja considerado um Acidente, deve cumprir a definição de acidente prevista no contrato e, além disso, enquadrar-se exclusivamente numa das seguintes situações:\n\nFraturas ou luxações articulares de origem traumática.\nLacerações cutâneas, feridas por mordedura (exceto picadas de insetos) ou escoriações cutâneas.\nQueimaduras ou lesões por eletrocussão.\nTraumatismos provocados por veículo.\nIntoxicações.\nFeridas por arma de fogo ou projétil.\nContusões graves ou lesões por esmagamento.\nLesões dentárias de origem traumática.\nCorpos estranhos gastrointestinais.\n\nAlém disso, as Condições Gerais estabelecem expressamente que as lesões ou condições que, mesmo existindo um acontecimento traumático, correspondam a uma patologia sujeita a um período de carência específico previsto no contrato ficam sujeitas a esse período de carência e não ao período aplicável aos Acidentes.\n\nPor este motivo, aplica-se a este processo o período de carência de 28 dias, e não o período de carência de 5 dias previsto para acidentes.\n\nUma vez que os sintomas e/ou o tratamento ocorreram durante esse período de carência, lamentavelmente não podemos reembolsar as despesas correspondentes."
          }
        ]
      },
      {
        "group": "As vacinas não estão em dia",
        "options": [
          {
            "label": "Vaccinations are not up to date",
            "value": "A vacinação anual não está atualizada. De acordo com as condições gerais da tua apólice, o teu animal de estimação deve ter em dia as vacinas contra as seguintes doenças: raiva, esgana, hepatite e parvovirose. Neste caso, o calendário de vacinação não está completo ou as indicações do teu veterinário não foram seguidas. As despesas veterinárias decorrentes do desenvolvimento desta doença não podem ser cobertas."
          }
        ]
      },
      {
        "group": "Disclaimers",
        "options": [
          {
            "label": "Disclaimer clinical history",
            "value": "Historial clínico. Gostaria de te lembrar que, para o teu próximo pedido de reembolso, precisamos que nos envies o historial médico do teu animal de estimação. O historial veterinário deve incluir, num único documento, todas as visitas ao veterinário, tanto por doença ou acidente, como as consultas de rotina ou de vacinação, com a data da visita e as notas veterinárias correspondentes. Caso tenhas ido a mais do que uma clínica, deves pedir este documento a todas. Cada página deste documento deve ser numerada e, na última página, precisamos da assinatura e do carimbo da clínica. Deves também acrescentar uma certificação de que as visitas enumeradas no historial são as únicas vezes que o teu animal de estimação foi a essa clínica."
          },
          {
            "label": "we cover this claim",
            "value": "Reembolsámos este tratamento. No entanto, ao submeter uma nova fatura relacionada com esta doença, poderão surgir questões médicas que, infelizmente, poderão impedir o reembolso de tratamentos futuros. "
          },
          {
            "label": "health expenses in prevention",
            "value": "A fatura que nos enviou inclui custos que não estão cobertos pelo seu contrato de cuidados preventivos. Caso considere que os procedimentos foram realizados devido a um problema de saúde, carregue, por favor, a fatura juntamente com o relatório dessa consulta na sua apólice de saúde."
          },
          {
            "label": "Complementary sessions limit reached",
            "value": "Já atingiu o seu limite anual de 8 sessões."
          },
          {
            "label": "Annual visit limit reached",
            "value": "Já utilizou a consulta anual coberta pela sua apólice."
          },
          {
            "label": "Unjustified costlines",
            "value": "Alguns dos custos indicados não estão suficientemente justificados na documentação apresentada e, por isso, não podem ser avaliados de acordo com as condições do seguro."
          },
          {
            "label": "Outside EU, UK and Andorra",
            "value": "A sua apólice não cobre despesas incorridas fora da União Europeia, Reino Unido e Andorra."
          },
          {
            "label": "Disclaimer chronic condition",
            "value": "Relatório de check-up. Lembramos-te que, para podermos reembolsar os medicamentos crónicos, é necessário um check-up a cada 6 meses. Necessitamos que nos envies o relatório de check-up juntamente com o teu próximo pedido."
          },
          {
            "label": "Prostheses, implants, pacemakers and transplants",
            "value": "De acordo com as Condições Gerais da sua apólice, estão excluídos os transplantes (incluindo os cuidados pré e pós-operatórios), os pacemakers, as próteses, os implantes (exceto os implantes de osteossíntese), bem como as partes do corpo ou as articulações artificiais."
          }
        ]
      },
      {
        "group": "Despesa Preventiva",
        "options": [
          {
            "label": "Routinary or prevention",
            "value": "Tratamento Preventivo. O Seguro Barkibu cobre apenas as despesas veterinárias resultantes de doença ou acidente. As despesas que nos enviaste estão relacionadas com tratamentos de rotina ou preventivos, pelo que não estão cobertas"
          }
        ]
      },
      {
        "group": "Pós-morte",
        "options": [
          {
            "label": "Our condolences",
            "value": "Em nome de toda a equipa Barkibu, quero enviar-te toda a força possível nestes tempos tão difíceis. Lamentamos muito o que aconteceu."
          }
        ]
      },
      {
        "group": "Prevenção",
        "options": [
          {
            "label": "Vaccination not covered",
            "value": "Vacina não coberta: O pacote de cuidados preventivos do teu Seguro Veterinário inclui a vacinação contra a raiva, a polivalente e a tosse do canil para os cães, e a vacinação contra a raiva, a trivalente e a leucemia para os gatos."
          },
          {
            "label": "Anual consultation with tests",
            "value": "Check-up anual com provas: O pacote de cuidados preventivos do teu Seguro Veterinário inclui um check-up preventivo anual, que não está relacionado com qualquer doença, acidente ou sintoma do animal de estimação. Este check-up não inclui exames ou análises a realizar no teu animal de estimação. O check-up que nos enviaste não cumpre estes requisitos, pelo que não está coberto."
          }
        ]
      }
    ]
  },
  "close_claim": {
    "templates": [
      {
        "group": "Closing reason",
        "options": [
          {
            "label": "Erroneous pet",
            "value": "Encerrámos o teu pedido porque as despesas que nos enviaste não correspondem ao animal segurado nesta apólice."
          },
          {
            "label": "petparent asked to close the claim",
            "value": "Encerrámos o teu pedido conforme nos pediste."
          },
          {
            "label": "Missing information",
            "value": "Encerrámos o teu pedido porque a documentação recebida não é suficiente para podermos analisá-lo.Através da app, indicámos quais os documentos necessários, mas infelizmente não os recebemos corretamente. Se quiseres que voltemos a analisar o caso, só precisas de criar um novo pedido com toda a informação solicitada."
          },
          {
            "label": "Duplicated invoice",
            "value": "Encerrámos o teu pedido porque as faturas anexadas já tinham sido incluídas noutro pedido anterior."
          },
          {
            "label": "Outstanding documents in another request",
            "value": "Encerrámos este pedido porque está relacionado com outro que continua em aberto e onde ainda aguardamos documentação da tua parte. Para continuares com o processo, basta carregares os documentos diretamente no pedido que aparece na app como “Falta documentação”."
          },
          {
            "label": "Suspended/cancelled policy",
            "value": "Encerrámos o teu pedido porque a tua apólice está atualmente suspensa. Tentámos entrar em contacto contigo algumas vezes para atualizar o pagamento e regularizar as mensalidades em atraso, mas ainda não foi possível. Assim que a situação estiver resolvida, poderás enviar um novo pedido pela app."
          },
          {
            "label": "Fraud",
            "value": "Após analisar a documentação apresentada, detetámos incongruências que nos impedem de aprovar o seu pedido.\n\nA partir de agora, toda a documentação para futuros reembolsos deverá ser enviada diretamente pela sua clínica veterinária para clinic@barkibu.com.\n\nAssim que a sua clínica a tiver enviado, é importante que reabra um pedido através da app com os mesmos documentos, indicando a nota: «A minha clínica já enviou a documentação», para que a possamos analisar.\n\nPor favor, para facilitar a gestão dos seus reembolsos, nunca crie um pedido com documentos que não nos tenham sido previamente enviados pela sua clínica para o e-mail acima indicado."
          },
          {
            "label": "No response from clinic",
            "value": "Encerrámos o teu pedido porque, com a documentação fornecida até ao momento, não dispomos de informação suficiente para emitir uma avaliação. Tentámos contactar a tua clínica várias vezes para completar a informação, mas sem sucesso.\n\nPara que possamos rever os teus pedidos, entra em contacto com a tua clínica para que verifiquem o seu email.\n\nAssim que nos responderem, poderás reabrir o pedido através da app."
          },
          {
            "label": "Fraud documentation from clinic",
            "value": "Devido a divergências detetadas em pedidos de reembolso anteriores, a partir de agora toda a documentação para futuros reembolsos deverá ser enviada diretamente pela tua clínica veterinária para clinic@barkibu.com.\n\nAssim que a tua clínica a tiver enviado, é importante que abras um novo pedido através da app com os mesmos documentos, indicando a nota: «A minha clínica já enviou a documentação», para que a possamos rever.\n\nPor favor, para facilitar a gestão dos teus reembolsos, nunca cries um pedido com documentos que não nos tenham sido previamente enviados pela tua clínica para o email acima indicado."
          }
        ]
      }
    ]
  }
}
